/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 28/01/2025
*/

import React from "react";
import { Grid, Typography, Button, Box } from "@mui/material";
import Styles from "./redFooter.module.css";
import { useNavigate } from "react-router-dom";
import HomeImage from "../../assets/images/Homepage.png"
import GooglePayBtn from "../../assets/images/product/google-play.png";
import ApplePayBtn from "../../assets/images/product/app-store-button.png";

export default function RedFooter() {


  return (
    <>
      <div className={Styles.redFooterOuterContainer}>

        <Grid container>
          <Grid size={6} item xs={12} md={5} >
            <>
            <Typography variant="h5" fontWeight={300} padding={5} >What are you waiting for?</Typography>
            <Typography variant="h2" fontWeight={800} paddingLeft={5} >Try for free</Typography>
            <Typography variant="body2" padding={5} >Launch party pitch technology user experience innovator buzz stealth MVP business model.</Typography>
            <Box className={Styles.redFooterPayStoreBtn}>
              <Button><img src={GooglePayBtn } className={Styles.payStoreBtn} alt="Google pay store" /></Button>
              <Button><img src={ApplePayBtn } className={Styles.payStoreBtn} alt="Apple Store" /></Button>
            </Box>
          </>
            
          </Grid>
          <Grid size={6} item xs={12} md={6} className={Styles.redFooterImage}>
            <img src={HomeImage} className={Styles.image} />
            <div className={Styles.circleBlack} >
              <div className={Styles.circleBlue}></div>
            </div>

          </Grid>
        </Grid>



      </div>
    </>
  );
}
